// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__xSJzK","label":"styles_label__zq7lf","caption":"styles_caption__zyiWp","description":"styles_description__w7hVH","content":"styles_content__PLwYa"};